export const ResetData = {
  timeline: {
    "BABY IS IN QUIET ALERT STATE": {
      x: 123.43523712735487,
      y: 3568.643024055675
    },
    "BABY PRESSES DOWN HARD, LABORING PERSON FEELS RECTAL PRESSURE": {
      x: 4156.675279047698,
      y: 4044.9352257267697
    },
    "BABY’S HEAD BEGINS TO CROWN": {
      x: 4157.338986451602,
      y: 663.9139087892155
    },
    "BAG OF WATERS MAY BREAK": {
      x: 1695.3627780022764,
      y: 1458.4365786263756
    },
    "BEST TIME TO USE NARCOTICS IF YOU THEY ARE IN YOUR PLAN": {
      x: 4531.886192117157,
      y: 1223.4113554388175
    },
    "BREASTFEEDING IS INITIATED": {
      x: 4552.571795138588,
      y: 3330.180380050938
    },
    "BURNINGS & STRETCHING IN PERINEUM": {
      x: 115.62046949605379,
      y: 4003.3600357471764
    },
    "CALL YOUR DOULA": {
      x: 1341.924206963903,
      y: 671.6327477688873
    },
    "CALL YOUR PROVIDER": {
      x: 562.948806446861,
      y: 683.5647224523628
    },
    "CERVIX IS 10CM": {
      x: 2303.3474246432465,
      y: 4024.5704680567046
    },
    "CERVIX OPENS 1-5CM": {
      x: 4507.930244065791,
      y: 2583.24552221773
    },
    "CERVIX OPENS 6-8CM": {
      x: 1061.4522298177073,
      y: 4045.1558430989494
    },
    "CHANGE POSITIONS OFTEN": {
      x: 596.7736651485799,
      y: 4026.6794833244007
    },
    "CONTRACTIONS ARE 1 MINUTE LONG": {
      x: 102.94594595715398,
      y: 1899.4622994713848
    },
    "CONTRACTIONS ARE 2-3 MINUTES APART": {
      x: 1734.306057365576,
      y: 651.0691265950283
    },
    "CONTRACTIONS ARE 20-45 SECONDS LONG": {
      x: 2158.917312692293,
      y: 1522.6474038086203
    },
    "CONTRACTIONS ARE 3-5 MINUTES APART": {
      x: 116.19970643486225,
      y: 1519.820477856299
    },
    "CONTRACTIONS ARE 5 – 20 MINUTES APART": {
      x: 85.55020520399366,
      y: 3222.039701381402
    },
    "CONTRACTIONS ARE HARD AND FAST WITH SMALL BREAKS": {
      x: 3352.154232975509,
      y: 607.6005248788165
    },
    "CONTRACTIONS LAST 60 – 90 SECONDS": {
      x: 111.9248945679936,
      y: 1123.8468001914252
    },
    "DRINK AND EAT": {
      x: 3403.691983771051,
      y: 4048.1212192796684
    },
    "HAPPY, EXCITED, AND": {
      "OR ANXIOUS": {
        x: 4528.505171852544,
        y: 1546.023781728934
      }
    },
    "IGNORE AND GO ON WITH REGULAR ACTIVITIES": {
      x: 1968.5415801417334,
      y: 4040.5000504177665
    },
    "LABOR IS RHYTHMIC AND PREDICTABLE": {
      x: 96.66437283158278,
      y: 2858.7850431601196
    },
    "LABORING PERSON FEELS LOTS OF PRESSURE IN BOTTOM": {
      x: 4509.545343403505,
      y: 4062.9060277251506
    },
    "LABORING PERSON HAS NEW ENERGY EVEN THOUGH THE WORK IS HARD": {
      x: 3053.869248535559,
      y: 4048.2138564303473
    },
    "LEAVE FOR HOSPITAL OR BIRTH CENTER": {
      x: 4521.464761503592,
      y: 3708.254925935203
    },
    "LOOSE AND FREQUENT BOWEL MOVEMENTS": {
      x: 2867.4894018648215,
      y: 630.0107290918348
    },
    "MILD CONTRACTIONS AND SHAKY LEGS": {
      x: 2701.9622919659987,
      y: 4031.7257826298564
    },
    "NITROUS CAN BE USED": {
      x: 1603.139241536458,
      y: 4052.1748860677067
    },
    "OPTIMAL TIMING FOR EPIDURAL IF IT IS IN YOUR PLAN": {
      x: 98.0733235677084,
      y: 2271.0469563802053
    },
    "PARTNER BEGINS TO WORK WITH LABORING PERSON": {
      x: 4519.861114664561,
      y: 861.3512850584209
    },
    "PLACENTA IS EXPELLED": {
      x: 162.47975438034325,
      y: 661.7734193288046
    },
    "TAKE A WALK": {
      x: 4537.5137036787655,
      y: 1877.1219655471714
    },
    "URINATE OFTEN": {
      x: 3741.2067281788804,
      y: 604.6661727729861
    },
    "USUALLY THE LONGEST PART OF LABOR": {
      x: 957.8322140621282,
      y: 662.9332699366973
    },
    "UTERUS FEELS HARD & STRONG": {
      x: 3763.402200614412,
      y: 4051.259470482662
    },
    "VAGINAL REPAIRS": {
      x: 4552.7563808036275,
      y: 2955.767953875423
    },
    "“I CAN’T DO THIS ANYMORE”": {
      x: 4536.569553359603,
      y: 2213.7820284199865
    }
  }
};
